module.exports = __webpack_public_path__ + "static/media/sg.26ea892b.png";